import ACaptionList from './index.vue';

ACaptionList.install = app => {
  app.component(ACaptionList.name, ACaptionList);
};

export default ACaptionList;
